import {inject, Injectable, } from '@angular/core';
import {find, forEach, get, includes, isEmpty, keys} from "lodash-es";
import {BaseComponent} from "@wms/components";
import {ApisService, NotificationService, WebserviceService} from "@wms/services";
import {getClonedObject, getValidJSON, triggerFn} from "@wm/core";
import {DB_CONSTANTS, WS_CONSTANTS} from "@wms/core";
import {isValidWebSocketURL} from "../../projects/core/src/utils/utils";
import X2JS from "x2js";
import {VARIABLE_CONSTANTS} from "@wms/variables";

@Injectable({
  providedIn: 'root'
})
export class WebscoketService extends BaseComponent{
  ws: any;
 viewMode: string;
  webServiceMessage: any;
  disableDialogActions: any;
  _socket: WebSocket | null;
  msgCount = 0;
  RUNTIME_CALL_MODE   = {
    PROXY   : 'PROXY',
    DIRECT  : 'DIRECT'
  }
  buildRequestBody: any;
  webService:any;
  primitiveMultipartTypes = ["string", "file"];
  PARAMETER_TYPE_KEY = "in";
  BASE_PATH_KEY     = 'x-WM-BASE_PATH';
  RELATIVE_PATH_KEY = 'x-WM-RELATIVE_PATH';
  SERVICE_TYPES = {
    BOOLEAN: DB_CONSTANTS.DATABASE_DATA_TYPES.boolean.java_type,
    DATE: DB_CONSTANTS.DATABASE_DATA_TYPES.date.java_type,
    DOUBLE: DB_CONSTANTS.DATABASE_DATA_TYPES.double.java_type,
    FLOAT: DB_CONSTANTS.DATABASE_DATA_TYPES.float.java_type,
    INTEGER: DB_CONSTANTS.DATABASE_DATA_TYPES.integer.java_type,
    LONG: DB_CONSTANTS.DATABASE_DATA_TYPES.long.java_type,
    STRING: DB_CONSTANTS.DATABASE_DATA_TYPES.string.java_type,
    DATE_TIME: "date-time",
    NUMBER: "number"
  };

  CONTENT_TYPE_KEY = VARIABLE_CONSTANTS.REST_SERVICE.CONTENT_TYPE_KEY;


 constructor(private notificationService: NotificationService, private apiService:ApisService) {
   super();
   this.webService = inject(WebserviceService);
   // Initialize ws with default values when service is first injected
   // Since Angular services are singletons, this runs only once
   this.ws = this.getDefaultWsConfig();
 }

  /**
   * Returns the default ws configuration object.
   * This is the single source of truth for all ws properties.
   */
  private getDefaultWsConfig(): any {
    // Define paramType first as it's used by other properties
    const paramType = {
      "QUERY": "QUERY",
      "HEADER": "HEADER",
      "PATH": "PATH",
      "BODY": "BODY",
      "AUTH": "AUTH",
      "OTHER": "OTHER",
      "FORMDATA": "formData"
    };

    // Define paramDataTypes
    const paramDataTypes = [
      {
        uiType: 'Boolean',
        type: this.SERVICE_TYPES.BOOLEAN,
        format: this.SERVICE_TYPES.BOOLEAN,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'Date',
        type: this.SERVICE_TYPES.STRING,
        format: this.SERVICE_TYPES.DATE,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'DateTime',
        type: this.SERVICE_TYPES.STRING,
        format: this.SERVICE_TYPES.DATE_TIME,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'Double',
        type: this.SERVICE_TYPES.NUMBER,
        format: this.SERVICE_TYPES.DOUBLE,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'Float',
        type: this.SERVICE_TYPES.NUMBER,
        format: this.SERVICE_TYPES.FLOAT,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'Integer',
        type: this.SERVICE_TYPES.INTEGER,
        format: 'int32',
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'Long',
        type: this.SERVICE_TYPES.INTEGER,
        format: 'int64',
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      },
      {
        uiType: 'String',
        type: this.SERVICE_TYPES.STRING,
        format: this.SERVICE_TYPES.STRING,
        disable: false,
        group: this.locale.LABEL_PROPERTY_UI_TYPE
      }
    ];

    // Create newQueryParam with all required properties
    const newQueryParam: any = {
      name: '',
      value: '',
      format: this.SERVICE_TYPES.STRING,
      type: this.SERVICE_TYPES.STRING
    };
    newQueryParam[this.PARAMETER_TYPE_KEY] = paramType.QUERY.toLowerCase();

    // Create newPathParam with all required properties
    const newPathParam: any = {
      name: '',
      type: this.SERVICE_TYPES.STRING
    };
    newPathParam[this.PARAMETER_TYPE_KEY] = paramType.PATH.toLowerCase();

    return {
      // Properties from import-api.component.ts resetWS()
      'inputParams': [],
      'headers': {},
      'newHeader': { 'name': '', 'value': '' },
      'stepCount': 1,
      'serviceNameOption': 'custom',
      'customServiceName': '',
      'serviceType': {
        REST: 'REST',
        SOAP: 'SOAP',
        WEBSOCKET: 'WEBSOCKET',
        OPENAPI: 'OPENAPI'
      },
      'activeEntity': '',
      'swaggerSource': 'URL',
      'bindingsfileUploadInputName': 'definition',
      'entities': [],
      'swaggerObject': {},
      'originalSpecFileId': '',

      // Properties from websocket.component.ts initialteWS()
      'webSocketUrl': 'wss://echo.websocket.org/',
      'websocket': {},
      'editorContent': '',
      'requestBody': '',
      'messages': [],
      'responseBody': undefined,
      'testNotRequired': false,
      'isUrlChanged': false,
      'editMode': false,
      'isUrlTested': false,
      'restInfoQuery': {},
      'restInfoPaths': [],
      'paramType': paramType,
      'paramDataTypeGroups': [this.locale.LABEL_PROPERTY_UI_TYPE],
      'paramDataTypes': paramDataTypes,
      'newQueryParam': newQueryParam,
      'newPathParam': newPathParam
    };
  }

  /**
   * Resets ws to default values.
   * Use this when you want to start fresh (e.g., going back, closing dialog).
   */
  resetWS(): void {
    this.ws = this.getDefaultWsConfig();
  }






  updateService(){
    this.toggleMessage(true, this.locale.LABEL_UPDATING_WEB_SOCKET_SERVICE, 'loading');
    this.configureService(() => {
      this.buildService(() => {
        this.toggleMessage(false);
        this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_WEB_SERVICE_SUCCESS);
        this.setServiceTestedStatus(false);
        // this.$emit('update-web-services-tree-node', getServiceId());
        this.closeSocket();
      });
    });
  }
  /**
   * if exists, closes an existing socket connection
   */
  closeSocket() {
    if (this._socket) {
      this.resetMsgCount();
      this._socket.close();
      this.clearSocket();
    }
  }

  /** * resets the message count variable*/
  resetMsgCount() {
    this.msgCount = 0;
  }

  /**
   * clears an existing socket connection variable
   */
  clearSocket() {
    this._socket = null;
  }

  setServiceTestedStatus(status: boolean) {
    this.ws.serviceTested = status;
  }

  // function for toggling loading, failure  and validation messages
  toggleMessage(show?: boolean, msg?: any, type?: string) {
    if (show) {
      this.webServiceMessage = { caption: msg || "", type: type };
      this.disableDialogActions = type === "loading";
    } else {
      this.disableDialogActions = false;
      this.webServiceMessage = null;
    }
  }

  processRequestBodyForImport(requestBody:any, type:any) {
    // get the customized relative URL (if path params embedded)
    let parameterizedUrl = this.ws.webSocketUrl ,
      urlProtocol,
      relativeUrl,
      slashIndex,
      index,
      endpoints,
      i,
      nEndpoints,
      j,
      nOperations,
      pathKey,
      pathObj,
      connectionParams,
      operationObject;

    parameterizedUrl = parameterizedUrl.split('://');
    urlProtocol = parameterizedUrl[0];
    parameterizedUrl = parameterizedUrl[1];
    requestBody.swagger.schemes[0] = urlProtocol;

    slashIndex    = parameterizedUrl.indexOf('/');
    slashIndex    = slashIndex === -1 ? parameterizedUrl.indexOf('?') : slashIndex;
    slashIndex    = slashIndex === -1 ? parameterizedUrl.length : slashIndex;
    requestBody.swagger.host = parameterizedUrl.substr(0, slashIndex);
    relativeUrl   = parameterizedUrl.substr(slashIndex, parameterizedUrl.length);
    index         = relativeUrl.indexOf('?') !== -1 ? relativeUrl.indexOf('?') : relativeUrl.length;
    relativeUrl   = relativeUrl.substring(0, index) || '/';
    // requestBody.swagger.basePath = relativeUrl;
    pathKey       = keys(requestBody.swagger.paths)[0];
    pathObj       = requestBody.swagger.paths[pathKey];
    operationObject = pathObj[keys(pathObj)[0]];
    operationObject.parameters    = operationObject.parameters || [];
    operationObject.parameters    = this.transformQueryParam(operationObject.parameters);

    //Remove content type for string/file type params
    // removeContentType(operationObject.parameters);

    requestBody.proxySettings  = {
      'web': this.ws.useProxyForWeb ? this.RUNTIME_CALL_MODE.PROXY : this.RUNTIME_CALL_MODE.DIRECT, // for web api, use proxy settings with which the call was made.
      'mobile': this.ws.useProxy ? this.RUNTIME_CALL_MODE.PROXY : this.RUNTIME_CALL_MODE.DIRECT, // for mobile api, use whatever is selected in the designer.
      'withCredentials': this.ws.withCredentials ? true : false // If direct call, then withCredentials flag should be sent or not.
    };
    requestBody.serviceId = this.ws.serviceName;
    endpoints = requestBody.swagger.paths;
    // update only the required endpoint and operation based on the filteredEndpoint and filteredOperation ids
    for (i = 0, nEndpoints = endpoints.length; i < nEndpoints; i++) {
      if (endpoints[i].id === requestBody.filteredEndPointId) {
        endpoints[i].relativePath = relativeUrl;
        for (j = 0, nOperations = endpoints[i].operations.length; j < nOperations; j++) {
          if (endpoints[i].operations[j].id === requestBody.filteredOperationId) {
            endpoints[i].operations[j].methodType = this.ws.serviceMethod;
            endpoints[i].operations[j].consumes   = this.ws.contentTypeKey ? [this.ws.contentTypeMap[this.ws.contentTypeKey]] : [];
            break;
          }
        }
        break;
      }
    }


    connectionParams = {
      'data'      : requestBody,
      'urlParams' : {
        'projectID': this.projectService.getProjectId()
      }
    };
    return connectionParams;
  }
  getBuildRequestBody() {
    return this.buildRequestBody;
  }

  buildService(success: any, error?: any) {
    let buildMethod = this.ws.editMode ? 'updateWebSocketService' : 'buildWebSocketService';
    this.webService[buildMethod](this.processRequestBodyForImport(this.getBuildRequestBody(), 'websocket')).then((response:any) => {
      triggerFn(success, response);
    }).catch((errorMsg: any) => {
      triggerFn(error, errorMsg);
    });
  }

  transformQueryParam(inputParams: any) {
    forEach(inputParams,  (param) => {
      if (param[this.PARAMETER_TYPE_KEY] === this.ws.paramType.QUERY.toLowerCase()) {
        this.setTypeBasedOnFormat(param);
      }
    });
    return inputParams;
  }

  setTypeBasedOnFormat(param: { format: string; type: any; }) {
    if (includes([this.SERVICE_TYPES.DATE_TIME, this.SERVICE_TYPES.DATE, this.SERVICE_TYPES.STRING, this.SERVICE_TYPES.BOOLEAN], param.format)) {
      param.type = this.SERVICE_TYPES.STRING;
    } else if (param.format === 'int64') {
      param.type = this.SERVICE_TYPES.LONG;
    } else if (param.format === 'int32') {
      param.type = this.SERVICE_TYPES.INTEGER;
    } else if (includes([this.SERVICE_TYPES.FLOAT, this.SERVICE_TYPES.DOUBLE], param.format)) {
      param.type = this.SERVICE_TYPES.NUMBER;
    }
  }

  getSampleResponse() {
    return this.ws.responseBody;
  }

  handleError(error: any, options?: { fallbackMsg?: any; type?: any }) {
    options = options || {};

    let fallbackMsg = options.fallbackMsg || "MESSAGE_ERROR_OCCURRED",
      errorType = options.type || "inline";

    error =
      typeof error === "string"
        ? error
        : this.locale[fallbackMsg] || fallbackMsg;

    // based on error type, display the error-message
    if (errorType === "inline") {
      this.toggleMessage(true, error, "error");
    } else {
      this.notificationService.show(
        "error",
        this.locale.MESSAGE_ERROR_TITLE,
        error
      );
    }
  }




  /**
   * Checks if the provided URL is a valid WebSocket URL
   * if not, throws respective error on the UI
   * @param url
   * @returns {boolean}
   */
  isValidURL(url: any) {
    if (!url) {
      this.handleError(
        this.locale.MESSAGE_WEBSERVICE_IMPORT_FIELD_MISSING +
        this.locale.LABEL_WEB_SERVICE_REST_URL
      );
      return false;
    }
    if (!isValidWebSocketURL(url)) {
      this.handleError(this.locale.MESSAGE_INVALID_WS_URL);
      return false;
    }
    return true;
  }



  /**
   * get the endpoint url entered
   * @returns {string}
   */
  getUrl() {
    return this.ws.webSocketUrl;
  }

  /**
   * get the endpoint url entered
   * @returns {string}
   */
  getUrlFromParameterizedUrl() {
    let url = this.getParameterizedUrlFn();
    //Replace query and path params with their values
    url = this.getUrlWithParamValues(url);
    return url;
  }
  //Replace query and path params with their values
  getUrlWithParamValues(url: string) {
    // let pathParams = eval("ws.inputParams | filter: {in: ws.paramType.PATH}");
    const pathParams = this.ws.inputParams.filter((param: { in: any; }) => param.in === this.ws.paramType.PATH);
    if (this.ws.restInfoQuery) {
      forEach(this.ws.restInfoQuery, (value, key) => {
        url = url.replace("{" + key + "}", value);
      });
    }
    if (!isEmpty(pathParams)) {
      this.ws.restInfoPaths = this.ws.restInfoPaths || {};
      forEach(pathParams, (param) => {
        url = url.replace(
          "{" + param.name + "}",
          this.ws.restInfoPaths[param.name]
        );
      });
    }
    return url;
  }



  xmlToJson(xmlString: any, includeRoot?: any): any {
    try {
      let x2js = new X2JS({
        emptyNodeForm: "object", // Changed to a valid option: "object" or "text"
        attributePrefix: "",
        enableToStringFunc: false
      });

      // Attempt to parse the XML string
      let json:any = x2js.xml2js(xmlString);

      // Handle invalid XML case
      if (json?.html?.body?.parsererror) {
        throw new Error("Invalid XML format");
      }

      // If includeRoot is false, return the first property in the JSON object
      if (!includeRoot && json) {
        json = get(json, Object.keys(json)[0]);
      }

      return json;
    } catch (error:any) {
      return null;
    }
  }



  configureService(success:any) {
    let params,
      responseBody = this.getSampleResponse(),
      jsonResponse = getValidJSON(responseBody) ? null : (this.xmlToJson(responseBody) || null),
      url = this.ws.editMode ? this.getUrlFromParameterizedUrl() : this.getUrl();
    // validate URL
    if (!this.isValidURL(url)) {
      return;
    }
    params = {
      "data": {
        'endpointAddress': url,
        "method": "GET",
        "contentType": "",
        "sampleRequestBody": this.getRequestBody(),
        "headers": {},
        "sampleWebSocketResponse": {
          "contentType": "",
          "statusCode": "",
          "convertedResponse": jsonResponse,
          "responseBody": responseBody
        },
        "authType": "NONE"
      },
      'urlParams' : {
        'projectID': this.projectService.getProjectId()
      }
    };
    this.toggleMessage(true, this.locale.LABEL_CONFIGURING_SOCKET_SERVICE, 'loading');
    this.webService.configureWebSocketService(params).then((response:any) => {
      this.setBuildRequestBody(response);
      this.processServiceSettings(response, this.ws.editMode, true);
      this.closeSocket();

      // increment the service setting step
      this.ws.stepCount += 1;
      this.toggleMessage(false);
      triggerFn(success);
    }).catch((error:any) => {
      this.handleError(error, {'fallbackMsg': 'error while configuring socket service, please check server logs for more info.'});
    });
  }

  setBuildRequestBody(body: any) {
    this.buildRequestBody = body;
  }

  processServiceSettings(
    settings: any,
    skipExtractInfo: boolean,
    extendInputParams: any
  ) {
    let pathObject =
        settings.swagger.paths[Object.keys(settings.swagger.paths)[0]],
      operationObject = pathObject[Object.keys(pathObject)[0]],
      existingInputParams = getClonedObject(this.ws.inputParams);

    operationObject.parameters = operationObject.parameters || [];
    // if skipExtractInfo flag is set,
    // then info extraction sent from backend is not required
    if (!skipExtractInfo) {
      this.ws.restURL     = this.getParameterizedUrl(settings.swagger);
      this.ws.serviceName = settings.serviceId;
    }
    if (extendInputParams) {
      this.ws.inputParams = operationObject.parameters;
      //push the additional params not existing in swagger response.
      forEach(existingInputParams, (parameterObj) => {
        let inputObj = find(this.ws.inputParams, { name: parameterObj.name });
        let paramObj = find(existingInputParams, { name: parameterObj.name });
        // changing the type of param based on its format (since type is configured as 'string' for server side properties)
        if (inputObj) {
          inputObj.type = paramObj.format || inputObj.type;
          //update the items.type for the params only if content type is not multipart/form-data
          if (inputObj.items && inputObj.in !== this.ws.paramType.FORMDATA) {
            inputObj.items.type = inputObj.type;
          }
        } else {
          this.ws.inputParams.push(parameterObj);
        }
      });
      forEach(this.ws.inputParams, (parameterObj) => {
        // update the type of header param
        if (parameterObj.in === this.ws.paramType.HEADER.toLowerCase()) {
          parameterObj.type = this.ws.cachedHeaderParamsType[parameterObj.name]
            ? this.ws.cachedHeaderParamsType[parameterObj.name]
            : parameterObj.type;
          parameterObj.items = {};
          parameterObj.items.type = parameterObj.type;
        }
      });
    }
    this.setParameterizedUrl(this.ws.inputParams);
    this.ws.operationName = operationObject[WS_CONSTANTS.OPERATION_NAME_KEY];
    this.ws.contentType = operationObject.consumes
      ? operationObject.consumes[0]
      : "";
    // this.onContentTypeChange();
    this.toggleMessage(false);

    // check auth params existence in the input params
    this.checkAuthParams(this.ws.inputParams);

    //set content type for string/file type params for model purpose
    this.setContentType(this.ws.inputParams);

    // cache the param test values for default service variables
    // this.cacheParamValues();
    // cache the header param types
    this.cacheHeaderParamsType();
  }


  setParameterizedUrl(val: any, type?: string) {
    let url = this.ws.webSocketUrl;
    // if parameterized url not set previously, return
    if (!url) {
      return;
    }

    let index = includes(url, "?") ? url.indexOf("?") : url.length,
      plainURL = url.substring(0, index),
      i = 0,
      params = "";

    // loop over each input param to form the parameterized url out of it
    forEach(val, (param) => {
      if (
        param[this.PARAMETER_TYPE_KEY].toUpperCase() === this.ws.paramType.QUERY
      ) {
        if (i === 0) {
          params += "?";
        } else {
          params += "&";
        }
        params += param.name + "=" + (this.ws.restInfoQuery[param.name] || "");
        i += 1;
      }
    });
    if (type === "websocket") {
      this.ws.webSocketUrl = plainURL + params;
    } else {
      this.ws.restURL = plainURL + params;
    }
  }


  /**
   * get the parameterizedUrl
   * @returns {string}
   */
  getParameterizedUrlFn() {
    return this.ws.webSocketUrl;
  }

  /**
   * get sample request body entered in UI
   * @returns {string|this.ws.requestBody|*}
   */
  getRequestBody() {
    return this.ws.requestBody;
  }




  /**
   * caches the Header param types
   */
  cacheHeaderParamsType() {
    this.ws.cachedHeaderParamsType = {};
    forEach(this.ws.inputParams, (paramObj) => {
      if (
        paramObj[this.PARAMETER_TYPE_KEY] ===
        this.ws.paramType.HEADER.toLowerCase()
      ) {
        this.ws.cachedHeaderParamsType[paramObj.name] =
          paramObj.format || paramObj.type;
      }
    });
  }


  /*
  * checks the existence of auth params in the params list
  * if found, sets the ws.basicAuthRequired to true
  * @param {params} list of input parameters
  */
  checkAuthParams(params: any) {
    forEach(params, (param) => {
      if (
        param[this.PARAMETER_TYPE_KEY].toUpperCase() ===
        this.ws.paramType.AUTH.toUpperCase()
      ) {
        this.ws.basicAuthRequired = true;

        // remove the 'wm_auth_' part from the auth parameters
        param.displayName = param.name.replace("wm_auth_", "");
      }
    });
  }


  getParameterizedUrl(swagger:any) {
    let paths           = swagger.paths,
      pathObject      = paths[keys(paths)[0]];

    return swagger.schemes[0] + '://' + swagger.host + swagger.basePath + pathObject[this.BASE_PATH_KEY] + pathObject[this.RELATIVE_PATH_KEY];
  }

  setContentType(params: any) {
    let paramType;
    forEach(params, (param) => {
      paramType = get(param, "items.type") || param.type;
      if (
        param[this.PARAMETER_TYPE_KEY] === this.ws.paramType.FORMDATA &&
        includes(this.primitiveMultipartTypes, paramType) &&
        !param[this.CONTENT_TYPE_KEY]
      ) {
        param[this.CONTENT_TYPE_KEY] = paramType;
      }
    });
  }

  deleteWebService($event:any){
    this.apiService.deleteEvent = $event;
    this.apiService._deleteSelectedService.next("deleteSelectedService");
  }





}
